import { memo } from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowForwardRounded from "@mui/icons-material/ArrowForwardRounded";
import { FullPaddingWrapper } from "../../Components/FullPaddingWrapper/FullPaddingWrapper";
import MessageUsPanel from "../../Components/MessageForm/MessageUsPanel";
import APP_ROUTES from "../../Configurations/APP_ROUTES";

/** /resources. Was a placeholder heading; now an index of the guides we have. */
const GUIDES = [
  {
    title: "True Cost Guide",
    body: "What common repairs and upgrades really cost, so a quote never surprises you.",
    to: APP_ROUTES.TRUE_COST_GUIDE.pathname,
  },
  {
    title: "Home Maintenance Guide",
    body: "What to check and when, season by season.",
    to: APP_ROUTES.HOME_MAINTENANCE_GUIDE.pathname,
  },
  {
    title: "Licensing Requirements",
    body: "Which jobs need a licensed contractor in California, and how to check one.",
    to: APP_ROUTES.LICENSING_REQUIREMENTS.pathname,
  },
  {
    title: "A Note from Our Team",
    body: "Why we built SimplerHome, and what's coming next.",
    to: APP_ROUTES.MESSAGE_FROM_TEAM.pathname,
  },
];

const Resources = memo(() => (
  <Container maxWidth="xl" disableGutters>
    <FullPaddingWrapper>
      <Box sx={{ pt: { xs: 3, md: 5 }, pb: { xs: 3, md: 5 } }}>
        <Typography variant="h3" component="h1" fontWeight={700} color="primary.main" sx={{ fontSize: { xs: "1.9rem", md: "2.5rem" }, mb: 1 }}>
          Homeowner resources
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 620 }}>
          Plain-English guides for looking after your home.
        </Typography>
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: { xs: 2, md: 3 }, mb: { xs: 5, md: 8 } }}>
        {GUIDES.map((g) => (
          <Stack
            key={g.title}
            component={Link}
            to={String(g.to)}
            spacing={1}
            sx={{
              p: { xs: 3, md: 4 },
              borderRadius: "16px",
              backgroundColor: "#f8f8f8",
              textDecoration: "none",
              color: "inherit",
              border: "1px solid transparent",
              transition: "border-color .15s",
              "&:hover, &:focus-visible": { borderColor: "primary.main" },
            }}
          >
            <Typography variant="h6" fontWeight={700} color="primary.main">
              {g.title}
            </Typography>
            <Typography variant="body1" color="#333" sx={{ flex: 1 }}>
              {g.body}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={0.5} sx={{ color: "primary.main", fontWeight: 600, pt: 1 }}>
              <span>Read the guide</span>
              <ArrowForwardRounded fontSize="small" />
            </Stack>
          </Stack>
        ))}
      </Box>

      <MessageUsPanel
        topic="general"
        title="Can't find what you need?"
        intro="Ask us anything about your home. We'll answer, and it may become the next guide."
      />
    </FullPaddingWrapper>
  </Container>
));

export default Resources;
